import { useAppQuery } from "./useAppQuery.js";

interface UseAllCollectionQueryOptions {
  onSuccess?: (shopData: { collection: any }) => void;
  onError?: (error: any) => void;
  enabled?: boolean;
}

export const useAllCollectionQuery = (options: UseAllCollectionQueryOptions) => {
  const {
    data,
    status,
    isLoading,
    isRefetching,
    isFetching,
    refetch,
  } = useAppQuery<{ collection: any }, Error>({
    url: "/api/shop/collection/all",
    reactQueryOptions: { ...options },
  });

  return {
    isLoading,
    isFetching,
    isRefetching,
    data,
    status,
    refetch,
  };
};